import React from 'react'

import { gray } from 'styles/colors'

const Edit = ({ className, active }) => (
  <svg
    className={className}
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    fill={gray}>
    <path
      stroke="none"
      strokeWidth="1"
      fillRule="evenodd"
      transform="translate(-1017.000000, -310.000000)"
      d="M1032.26,313.86 L1030.74,315.38 L1027.62,312.26 L1029.14,310.74 C1029.3,310.579999 1029.49667,310.5 1029.73,310.5 C1029.96333,310.5 1030.16,310.579999 1030.32,310.74 L1032.26,312.68 C1032.42,312.840001 1032.5,313.036666 1032.5,313.27 C1032.5,313.503334 1032.42,313.699999 1032.26,313.86 Z M1017.5,322.38 L1026.72,313.16 L1029.84,316.28 L1020.62,325.5 L1017.5,325.5 L1017.5,322.38 Z"
    />
  </svg>
)

export default Edit



// WEBPACK FOOTER //
// ./src/components/icons/Edit.js